<mbs-modal
  #modal
  [isCustomModal]="true"
  [showFooter]="true"
  [title]="'shared:accessReview.title' | i18next"
  [titleTextOverflow]="true">
  <div modal-body>
    <p class="mb-2">{{ 'shared:accessReview.intro' | i18next }}</p>
    <p class="mb-2">{{ 'shared:accessReview.howTo' | i18next }}</p>
    <p
      class="mb-2"
      [innerHTML]="'shared:accessReview.moreInfo' | i18next: { codeOfConductUrl: codeOfConductUrl, trustSafetyUrl: trustSafetyUrl }"></p>
    <p class="mb-2">{{ 'shared:accessReview.verifyHint' | i18next }}</p>
    <p class="mb-0">{{ 'shared:accessReview.thanks' | i18next }}</p>
  </div>
  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [loading]="loading"
      (click)="requestAccess()"
      >{{ 'shared:accessReview.requestAccess' | i18next }}
    </mbs-button>
    <mbs-button
      data-dismiss="modal"
      type="secondary"
      (click)="modal.close()"
      >{{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
